// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: "https://back.homolog.omnilinker.cloud/monitor/api/" //"http://189.1.174.141:57778/monitor/api/" //"http://back.homolog.omnilinker.cloud/"
};
